import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AdaptiveFilter,
  Box,
  Option,
  OptionKey,
  RawButton,
  Text,
  useResponsive,
} from '@common-fe/common-fe';

import { SpendLimitsPeriodFilter } from './SpendLimitsPeriodFilter';

interface SpendLimitsPeriodHeaderProps {
  title: string;
  showPeriodDropdown?: boolean;
  periodOptions: Option[];
  selectedPeriod?: OptionKey;
  onPeriodChange?: (value: OptionKey) => void;
  isPeriodLoading?: boolean;
  hideBackground?: boolean;
  testIdPrefix: string;
}

export const SpendLimitsPeriodHeader: React.FC<SpendLimitsPeriodHeaderProps> = ({
  title,
  showPeriodDropdown,
  periodOptions,
  selectedPeriod,
  onPeriodChange,
  isPeriodLoading,
  hideBackground,
  testIdPrefix,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const {
    isFilterVisible,
    setIsFilterVisible,
    handleCancelFilter,
    handleSubmitFilter,
    isFilterApplied,
    handleResetFilter,
    filters,
    setFilter,
  } = AdaptiveFilter.useAdaptiveFilter<{
    period: OptionKey;
  }>({
    initialFilters: {
      period: selectedPeriod || '',
    },
    onSubmit: (appliedFilters) => {
      onPeriodChange?.(appliedFilters.period);
    },
  });

  return (
    <>
      <Box
        margin={{ bottom: (isMobile && isFilterApplied) ? 'spacing12' : 'spacing24' }}
        direction="row"
        align="center"
        justify="between"
      >
        <Box>
          <Text weight="bold" color="textTitle" size="large" style={{ whiteSpace: 'nowrap' }}>
            {title}
          </Text>
        </Box>
        {showPeriodDropdown && (
          <SpendLimitsPeriodFilter
            isMobile={isMobile}
            periodOptions={periodOptions}
            selectedPeriod={selectedPeriod}
            onPeriodChange={onPeriodChange}
            isPeriodLoading={isPeriodLoading}
            testIdPrefix={testIdPrefix}
            isFilterApplied={isFilterApplied}
            isFilterVisible={isFilterVisible}
            setIsFilterVisible={setIsFilterVisible}
            handleCancelFilter={handleCancelFilter}
            handleSubmitFilter={handleSubmitFilter}
            handleResetFilter={handleResetFilter}
            filterPeriodValue={filters.period ? [filters.period] : []}
            onFilterPeriodChange={(value) => setFilter('period', value[0] || '')}
          />
        )}
      </Box>
      {isMobile && isFilterApplied && (
        <Box
          pad={{ horizontal: hideBackground ? undefined : 'l' }}
          direction="row"
          justify="end"
          margin={{ bottom: 'spacing24' }}
        >
          <RawButton onClick={handleResetFilter}>
            <Text size="large" weight={700} color="buttonPrimary">
              {t('Clear All')}
            </Text>
          </RawButton>
        </Box>
      )}
    </>
  );
};
